import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import './Objeto.css';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
//star rating
import Star from '../ui/Stars';
import { urls } from '../router/urls';

const Objeto = ({ img, titulo, resources, id, descripcion, is_group, is_related }) => {
  const { i18n, t } = useTranslation();
  const [stars, setStars] = useState(0);

  const get_qualification = useCallback(
    () => {
      axios
        .get(urls.url_api + `/api/resource-objects/${id}/average_ranking/`)
        .then(response => {
          let q = response.data.average_ranking;
          setStars(q);
        })
        .catch(err => {
          setStars(0);
        });
    },
    [id, setStars]
  );

  useEffect(() => {
    get_qualification();
    i18n.changeLanguage(localStorage.getItem('lang'));
  }, [get_qualification, i18n]);

  return (
    <div className={'card card-collec m-3'} role="article">
      <div>
        {is_group ? (
          is_related ? (
            /* grupo en contenidos relacionados */
            <>
              <a href={`/${urls.agrupaciones}/${id}`} title={titulo} aria-label={t('objeto_view_group_aria', { title: titulo })}>
                {img === '' ? (
                  ''
                ) : (
                  <img
                    src={img}
                    className="card-img collect-img"
                    style={{ width: '100% !important' }}
                    alt={t('objeto_image_alt', { title: titulo })}
                  />
                )}
              </a>
            </>
          ) : (
            /* grupo normal */
            <Link to={`${urls.agrupaciones}/${id}`} title={titulo} aria-label={t('objeto_view_group_aria', { title: titulo })}>
              {img === '' ? (
                ''
              ) : (
                <img
                  src={img}
                  className="card-img collect-img"
                  style={{ width: '100% !important' }}
                  alt={t('objeto_image_alt', { title: titulo })}
                />
              )}
            </Link>
          )
        ) : is_related ? (
          /* recursos relacionados */
          <>
            <a href={`/${urls.recursos}/${id}`} title={titulo} aria-label={t('objeto_view_resource_aria', { title: titulo })}>
              {img === '' ? (
                ''
              ) : (
                <img
                  src={img}
                  className="card-img collect-img"
                  style={{ width: '100% !important' }}
                  alt={t('objeto_image_alt', { title: titulo })}
                />
              )}
            </a>
          </>
        ) : (
          /* recursos normales */
          <Link to={`${urls.recursos}/${id}`} title={titulo} aria-label={t('objeto_view_resource_aria', { title: titulo })}>
            {img === '' ? (
              ''
            ) : (
              <img
                src={img}
                className="card-img collect-img"
                style={{ width: '100% !important' }}
                alt={t('objeto_image_alt', { title: titulo })}
              />
            )}
          </Link>
        )}
      </div>

      <div className="card-body">
        <div className="tag-area">
          <div className="tag-item">
            Ciencias Sociales
          </div>
        </div>
        {is_group ? (
          is_related ? (
            /* grupo en contenidos relacionados */
            <>
              <Link to={`/${urls.agrupaciones}/${id}`} title={titulo} aria-label={t('objeto_view_group_aria', { title: titulo })}>
                <h5 className="link-pwa">{titulo}</h5>
              </Link>
            </>
          ) : (
            /* grupo normal */
            <Link to={`${urls.agrupaciones}/${id}`} title={titulo} aria-label={t('objeto_view_group_aria', { title: titulo })}>
              <h5 className="link-pwa">{titulo}</h5>
            </Link>
          )
        ) : is_related ? (
          /* recursos relacionados*/
          <>
            <Link to={`/${urls.recursos}/${id}`} title={titulo} aria-label={t('objeto_view_resource_aria', { title: titulo })}>
              <h5 className="link-pwa">{titulo}</h5>
            </Link>
          </>
        ) : (
          /* recursos relacionados*/
          <Link to={`${urls.recursos}/${id}`} title={titulo} aria-label={t('objeto_view_resource_aria', { title: titulo })}>
            <h5 className="link-pwa">{titulo}</h5>
          </Link>
        )}
        <div className='resources-count' aria-label={t('objeto_resources_count_aria', { count: resources.length })}>
          {resources.length} {resources.length === 1 ? t('objeto_resource_singular') : t('objeto_resource_plural')}
        </div>
        <div className="stars-icon-pwa">
          <Star rating={stars} />
          <span className='stars-pwa' aria-label={t('objeto_average_rating_aria', { rating: stars })}>{' ' + stars + '.0'}</span>
        </div>

        <span className="text-concat">{descripcion}</span>
        <div className='text-collec'>
        <Link to={`${urls.recursos}/${id}`} title={titulo} aria-label={t('objeto_view_resource_aria', { title: titulo })}>
            {t('objeto_view_collection')}
          </Link>
          <i className="far fa-arrow-alt-circle-right"></i>
        </div>
      </div>
    </div>
  );
};

export default Objeto;
